module.exports = __webpack_public_path__ + "static/media/log.8e213739.png";